var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Carousel',{attrs:{"carousel":_vm.carousel,"mobile":_vm.mobile}}),_vm._v(" "),_c('About'),_vm._v(" "),_c('Clients',{attrs:{"clients":_vm.clients}}),_vm._v(" "),_c('Testmonial',{attrs:{"testimonial":_vm.testimonial}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63910f36","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 92
// module chunks = 0